export const mockFields = (fieldNames) => {
  const mock = fieldNames || ["Favorite Color", "Shirt Size", "Number of Pets", "Favorite Movie"];
  return mock.map((description, i) => ({
    enabled: i % 2 === 0,
    ID: i + 1,
    description,
    order: i + 1,
    canReorder: true,
  }));
};
export const mockGroups = (groupNames) => {
  const mock = groupNames || ["Group One", "Group Two", "Group Three"];
  return mock.map((groupName, i) => ({
    groupID: i + 1,
    groupName,
    shortName: groupName.split(" ").join("-").toLowerCase(),
  }));
};
export const mockFunds = (fundNames) => {
  // return [];
  const mock = fundNames || ["Mock General Fund", "Fund Two", "Fund Three"];
  return mock.map((fundDescription, i) => ({
    fundID: i+1,
    fundDescription,
  }));
};
export const mockSignups = (signupNames) => {
  const mock = signupNames || ["Signup One", "Signup Two", "Signup Three"];
  return mock.map((signupTitle, i) => ({
    signupID: i+1,
    signupTitle,
  }));
};
export const mockUsers = (userNames) => {
  const mock = userNames || ["Lucille McGilicuddy", "Lucille Bluth", "Lucille Austero"];
  return mock.map((fullName, i) => ({
    userID: i+1,
    fullName,
  }));
};